import React, { Component } from "react";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import sucesso from "../assets/sucesso.png";

class FormularioEnviado extends Component {
  goBack = () => {
    this.props.history.replace("/");
  };
  render() {
    return (
      <React.Fragment>
        <header className="background-home"></header>
        <div className="app flex-row align-items-center">
          <Container className="mt-5">
            <Row className="justify-content-center">
              <Col md="9">
                <Card className="p-4 align-items-center">
                  <CardTitle>
                    <h3>Cadastro realizado com sucesso!</h3>
                  </CardTitle>
                  <CardBody>
                    <Row>
                      <img
                        style={{ height: "280px" }}
                        src={sucesso}
                        alt="Sucesso"
                      ></img>
                    </Row>
                    <Row>
                      <Col className="text-center mt-4">
                        <button
                          type="button"
                          onClick={this.goBack}
                          className={"btn btn-success btn-lg btn-block"}
                        >
                          Voltar
                        </button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default FormularioEnviado;
